"use strict";
const isNum = (value) => typeof value === "number" && !Number.isNaN(value);
const relativeEventPosition = (ev, toElement) => {
  const { left, top } = toElement.getBoundingClientRect();
  let pageX = 0;
  let pageY = 0;
  if ("touches" in ev) {
    const touch = ev.touches[0];
    if (touch) {
      if (isNum(touch.pageX) && isNum(touch.pageY)) {
        pageX = touch.pageX;
        pageY = touch.pageY;
      } else if (isNum(touch.clientX) && isNum(touch.clientY)) {
        pageX = touch.clientX;
        pageY = touch.clientY;
      }
    }
  } else if (isNum(ev.pageX) && isNum(ev.pageY)) {
    pageX = ev.pageX;
    pageY = ev.pageY;
  }
  return {
    x: pageX - left,
    y: pageY - top
  };
};
export default relativeEventPosition;
